import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { checkParams } from "../../../src/util/Util";
import Select from "../select/Select";
import Breadcrumbs from "../breadcrumbs/Breadcrumbs";
import { useNavigate } from "react-router-dom";
import "./AddPtForm.css";

const AddPtForm = (props) => {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [errorFirstName, setErrorFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [errorLastName, setErrorLastName] = useState("");
  const [email, setEmail] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [errorRole, setErrorRole] = useState("");
  const [therapistRole, setTherapistRole] = useState("");
  const [businessCompanies, setBusinessCompanies] = useState([]);
  const [companyId, setCompanyId] = useState("");
  const [companySelected, setCompanySelected] = useState("");
  // eslint-disable-next-line
  const [companyError, setCompanyError] = useState("");
  const [errorEmailTaken, setErrorEmailTaken] = useState(false);
  /* const [ptFormHeight, setPtFormHeight] = useState(0); */
  const [therapistRoles] = useState([
    { value: "Therapist Admin" },
    { value: "Therapist" },
    { value: "Therapist Assistant" },
    { value: "Wellness Coach" },
  ]);
  const [isCompanyAdmin, setCompanyAdmin] = useState(false);
  const [succPopUp, setSuccPopUp] = useState(false);
  const handleCompanyAdmin = (val) => {
    setCompanyAdmin(val);
  };

  const superAdmin =
    localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).super_admin
      : 0;

  useEffect(() => {
    props.actSidebar(false);
    // eslint-disable-next-line
  }, []);
  const popupRef = useRef(succPopUp);
  useEffect(() => {
    popupRef.current = succPopUp;
    const timeout = setTimeout(() => {
      setSuccPopUp("");
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [succPopUp]);

  /* useEffect(() => {
    setPtFormHeight(window.innerHeight + 250);
  }, []); */

  const handleFirstName = (val) => {
    val = val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
    setFirstName(val);
    if (!checkParams(val.trim(), "firstname")) {
      setErrorFirstName("Please enter a valid first name.");
    } else if (val.trim().length > 15) {
      setErrorFirstName("Maximal numbers of letters is 15.");
    } else {
      setErrorFirstName("");
    }
  };

  const handleLastName = (val) => {
    val = val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
    setLastName(val);
    if (!checkParams(val.trim(), "lastname")) {
      setErrorLastName("Please enter a valid last name.");
    } else if (val.trim().length > 15) {
      setErrorLastName("Maximal numbers of letters is 15.");
    } else {
      setErrorLastName("");
    }
  };

  const handleEmail = (val) => {
    setEmail(val);
    if (!checkParams(val.trim(), "email") || val.trim().length > 50) {
      setErrorEmail("Please enter a valid email address.");
    } else {
      setErrorEmail("");
    }
  };

  const handleCompany = (val) => {
    setCompanySelected(val);
    if (!val) {
      setCompanyError("Please fill in Company / Practice.");
    } else {
      setCompanyError("");
    }
  };

  const handleTherapistRole = (mod, val) => {
    mod(val);

    if (!val) {
      setErrorRole("Please choose a valid therapist role.");
    } else {
      setErrorRole("");
    }
  };

  const handleInvite = () => {
    handleLastName(lastName);
    handleFirstName(firstName);
    !errorEmailTaken && handleEmail(email);
    handleTherapistRole(setTherapistRole, therapistRole);
    superAdmin === 1 && handleCompany(companySelected);

    let errorEmpty = !firstName || !lastName || !email || !therapistRole;
    let errorIncorrect = errorFirstName || errorLastName || errorEmail;

    if (!errorEmpty && !errorIncorrect) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_therapist/save-new-therapist", {
          firstName,
          lastName,
          email: email.trim().toLowerCase(),
          therapistRole,
          isCompanyAdmin,
          companyId,
        })
        .then(() => {
          setSuccPopUp(true);
          setFirstName("");
          setErrorFirstName("");
          setLastName("");
          setErrorLastName("");
          setEmail("");
          setErrorEmail("");
          setErrorRole("");
          setTherapistRole("");
          setCompanyAdmin(false);
          localStorage.setItem("AddedNewTherapist", true);
          navigate("/settings");
        })
        .catch((error) => {
          if (error.response.data.responseCode === 400) {
            setErrorEmail(error.response.data.errorData.emailErr);
            setErrorEmailTaken(true);
          }
        });
    }
  };

  useEffect(() => {
    var userData = JSON.parse(localStorage.getItem("userData"));
    if (userData === null) {
      props.checkLoggedIn(false);
    } else {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_programs/get-companies-by-bi", {
          business_id: userData.business_id,
        })
        .then((res) => {
          if (res.data.responseData) {
            setBusinessCompanies(res.data.responseData);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
    // eslint-disable-next-line
  }, []);

  const handleCompanyList = (callVal, value) => {
    if (callVal && value) {
      for (let i of businessCompanies) {
        if (i.key === value) {
          setCompanySelected(i.value);
        }
      }
      callVal(value);
      setCompanyError("");
    }
  };

  return (
    <div className="patient_settings_container">
      <Breadcrumbs></Breadcrumbs>
      <div className="add_member_title_and_btn_holder">
        <div className="prog_det_title_hold">
          <div className="prog_det_title">Add New Therapist</div>
        </div>
      </div>
      <div className="add_member_hold add_pt_hold">
        {/* <div className="input_wrapper pt_form_wrap" style={{height: "600px"}}> */}
        {succPopUp && (
          <div className="prog_err_hold prog_pop_pat_correct">
            <div className="prog_pop_icon_correct prog_err_icon"></div>
            <div className="prog_err_text prog_pop_text_correct">Therapist has been successfully invited.</div>
          </div>
        )}
        <div className="add_member_patient_title">Therapist Details</div>
        <div className="bottom_toggle_txt">First Name</div>
        <input
          placeholder="Enter First Name"
          type="text"
          value={firstName}
          className="patient_info_input"
          onChange={(e) => handleFirstName(e.currentTarget.value)}
        />
        {errorFirstName && <div className="email_error_msg">{errorFirstName}</div>}
        <div className="bottom_toggle_txt">Last Name</div>
        <input
          placeholder="Enter Last Name"
          type="text"
          value={lastName}
          className="patient_info_input"
          onChange={(e) => handleLastName(e.currentTarget.value)}
        />
        {errorLastName && <div className="email_error_msg">{errorLastName}</div>}
        <div className="bottom_toggle_txt">Email</div>
        <input
          placeholder="Enter Email"
          type="text"
          value={email}
          className="patient_info_input"
          onChange={(e) => handleEmail(e.currentTarget.value)}
        />
        {errorEmail && <div className="email_error_msg">{errorEmail}</div>}
        {superAdmin === 1 && (
          <div>
            <div className="bottom_toggle_txt">Company / Practice</div>
            <div className="relative_holder reg_select_wrapper mg-5 company_pick_add_therapist">
              <div style={{ marginBottom: "10px" }}>
                <Select
                  placeholder={"Select Company"}
                  selectOptions={businessCompanies}
                  initVal={companySelected}
                  selectCallback={function (callVal, value) {
                    handleCompanyList(callVal, value);
                  }}
                  callBackValue={setCompanyId}
                />
              </div>
            </div>
            {/* {companyError && <div className="email_error_msg">{companyError}</div>} */}
          </div>
        )}
        <div className="bottom_toggle_txt">Therapist Role</div>
        <div className="relative_holder sett_add_pt_drop">
          <Select
            initVal={therapistRole}
            placeholder={"Select Role"}
            selectOptions={therapistRoles}
            selectCallback={function (callVal, value) {
              handleTherapistRole(callVal, value);
            }}
            callBackValue={setTherapistRole}
          />
        </div>
        {errorRole && <div className="email_error_msg">{errorRole}</div>}
        <div className="sett_add_pt_check">
          <div className="sett_add_pt_check_text">Company Admin:</div>
          <div
            className={"register_check " + (isCompanyAdmin ? "register_checked" : "")}
            onClick={() => handleCompanyAdmin(!isCompanyAdmin)}
          ></div>
        </div>
        <div className="save_btn_add_member sett_add_new_button" onClick={() => handleInvite()}>
          Invite
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default AddPtForm;
